const weekdays = {
  "SUNDAY": 0,
  "SUN": 0,
  "MONDAY": 1,
  "MON": 1,
  "TUESDAY": 2,
  "TUE": 2,
  "WEDNESDAY": 3,
  "WED": 3,
  "THURSDAY": 4,
  "THU": 4,
  "FRIDAY": 5,
  "FRI": 5,
  "SATURDAY": 6,
  "SAT": 6,
  "TODAY": 7,
  "TOMORROW": 8
};

export default weekdays;